export const Menu_items = [
    {
        title: 'Home',
        url: '/',
        class_name: 'Nav-link',
        icon: "fa-solid fa-house-user",
        id: 1
    },
    {
        title: 'About',
        url: '/about',
        class_name: 'Nav-link',
        icon: 'fa-solid fa-circle-info',
        id: 2
    },
    {
        title: 'Service',
        url: '/service',
        class_name: 'Nav-link',
        icon: 'fa-solid fa-briefcase', id: 3
    },
    {
        title: 'Contact',
        url: '/contact',
        class_name: 'Nav-link',
        icon: 'fa-solid  fa-address-book', id: 4
    },
    {
        title: 'Sing Up',
        url: '/singup',
        class_name: 'Nav-link Nav-link--mobile', id: 5
    }
]